// HomePage.jsx

import React, { useState, useEffect } from "react";
import { Carousel } from "antd";
import Banner from "../../components/Banner";
import axios from "../../utils/request";
import { en, ch } from "../../utils/content";
import "./index.css";
import { useNavigate } from "react-router-dom";
import InfinitePartnerScroll from "../../components/InfinitePartnerScroll";

const HomePage = () => {
  const navigate = useNavigate();
  const [solutionActive, setSolutionActive] = useState(0);
  const [firstTabs, setFirstTabs] = useState<any>([]);
  const [products, setProducts] = useState<any>([]);
  const [productActive, setProductActive] = useState<any>(0);
  const [companyInfo, setCompanyInfo] = useState<any>({});
  const [companyImg, setCompanyImg] = useState<any>([]);
  const [cases, setCases] = useState<any>([]);
  const [news, setNews] = useState<any>([]);
  const [firends, setFirends] = useState<any>([]);
  const chunkArray = (array: any, len: number) => {
    let result = [];
    for (let i = 0; i < array.length; i += len) {
      result.push(array.slice(i, i + len));
    }
    return result;
  };
  const getCase = async () => {
    const res: any = await axios.get("/index/cases");
    if (res.code === 200) {
      setCases(chunkArray(res.data.data || [], 3));
    }
  };
  const getNews = async () => {
    const res: any = await axios.get("/index/news");
    if (res.code === 200) {
      setNews(res.data.data);
    }
  };
  const getProducts = async (id: number) => {
    const res: any = await axios.get("/index/product", {
      params: { cId: id },
    } as any);
    if (res.code === 200) {
      setProducts(res.data.data);
    }
  };
  const getTabs = async () => {
    const res: any = await axios.get("/index/product/class");
    if (res.code === 200) {
      setFirstTabs(res.data);
      getProducts(res.data[0]?.id);
    }
  };
  const getFirend = async () => {
    const res: any = await axios.get("/index/index/partner");
    if (res.code === 200) {
      setFirends(res.data.data);
    }
  };
  const initData = async () => {
    const res: any = await axios.get("/index/index/site");
    if (res.code === 200) {
      setCompanyInfo(res.data);
    }
    const imgRes: any = await axios.get("/index/images");
    if (imgRes.code === 200) {
      setCompanyImg(imgRes.data.data);
    }
    getCase();
    getNews();
    getTabs();
    getFirend();
  };
  useEffect(() => {
    initData();
  }, []);
  const lang = sessionStorage.getItem("lang") || "ch";
  const TXT_INFO = lang === "en" ? en : ch;

  return (
    <div className="home">
      {/* banner */}
      <Banner isShowBtn={true} />
      {/* 智能解决方案 */}
      <div className="solution">
        <div className="title">{TXT_INFO.product}</div>
        <div
          className="more"
          onClick={() => {
            navigate("/product");
          }}
        >
          {TXT_INFO.more}
        </div>
        <div className="s-container">
          <div className="sc-title">
            {firstTabs.map((item: any, index: number) => {
              return (
                <div
                  className={`sc-t-li ${
                    solutionActive === index ? "active" : ""
                  }`}
                  onClick={() => {
                    setSolutionActive(index);
                    setProductActive(0);
                    getProducts(item.id);
                  }}
                >
                  {item.title}
                </div>
              );
            })}
          </div>
          {products?.length ? (
            <div
              className="sc-box"
              onClick={() => {
                navigate("/detail", {
                  state: {
                    url: "/index/product/detail",
                    id: products?.[productActive]?.id,
                  },
                });
              }}
            >
              <div className="sc-b-img">
                <img src={products?.[productActive]?.img} />
              </div>
              <div className="sc-b-content">
                <div className="sc-b-c-title">
                  {products?.[productActive]?.name}
                </div>
                <div className="label-li">
                  {/* <div className="left">{TXT_INFO.productIntroduce}</div> */}
                  <div className="right">
                    {products?.[productActive]?.intro}
                  </div>
                </div>
                <div className="label-li-imgs">
                  {products?.[productActive]?.imgs?.map(
                    (
                      item: string | undefined,
                      index: React.Key | null | undefined
                    ) => {
                      return (
                        <div className="label-li-img">
                          <img className="img" src={item} key={index} />
                        </div>
                      );
                    }
                  )}
                </div>
              </div>
            </div>
          ) : null}
          <div className="sc-box mini">
            {products?.length ? (
              <Carousel
                dots={{ className: "dot-css" }}
                effect="fade"
                autoplay={true}
                speed={1000}
                draggable={true}
                autoplaySpeed={5000}
                adaptiveHeight={true}
              >
                {products?.map((item: any) => {
                  return (
                    <div
                      className="sc-b-li"
                      onClick={() => {
                        navigate("/detail", {
                          state: {
                            url: "/index/product/detail",
                            id: item?.id,
                          },
                        });
                      }}
                    >
                      <img className="sc-b-li-img" src={item.img} />
                      <div className="sc-b-li-title">{item.name}</div>
                    </div>
                  );
                })}
              </Carousel>
            ) : null}
          </div>
        </div>
        <div className="s-tab-box">
          <div className="s-tab">
            {products.map((item: any, index: number) => {
              return (
                <div
                  className={`s-t-li ${
                    productActive === index ? "active" : ""
                  }`}
                  onClick={() => {
                    setProductActive(index);
                  }}
                >
                  {item.name}
                </div>
              );
            })}
          </div>
        </div>
      </div>
      {/* 新闻动态 */}
      <div className="news">
        <div className="title">{TXT_INFO.news}</div>
        <div
          className="more"
          onClick={() => {
            navigate("/news");
          }}
        >
          {TXT_INFO.more}
        </div>
        <div className="n-container">
          <div
            className="n-c-l"
            onClick={() => {
              navigate("/detail", {
                state: {
                  url: "/index/news/detail",
                  id: news?.[0]?.id,
                },
              });
            }}
          >
            <img className="n-c-l-img" src={news?.[0]?.img} alt="news-img" />
            <div className="n-c-l-info">
              <div className="n-c-l-i-title">{news?.[0]?.title}</div>
              <div className="n-c-l-i-detail">{news?.[0]?.detail}</div>
              <div className="n-c-l-i-date">{news?.[0]?.created_time}</div>
            </div>
          </div>
          <div className="n-c-r">
            {news?.map((item: any, index: number) => {
              return index > 0 ? (
                <div
                  key={index}
                  className="n-c-r-li"
                  onClick={() => {
                    navigate("/detail", {
                      state: {
                        url: "/index/news/detail",
                        id: item?.id,
                      },
                    });
                  }}
                >
                  <div className="n-c-r-l-title">{item?.title}</div>
                  <div className="n-c-r-l-detail">{item?.detail}</div>
                  <div className="n-c-r-l-date">{item?.created_time}</div>
                </div>
              ) : null;
            })}
          </div>
        </div>
      </div>
      {/* 公司理念 */}
      <div className="idea">
        <div className="title">{TXT_INFO.company}</div>
        <div className="i-container">
          {TXT_INFO.companyList.map((item: any, index: number) => {
            return (
              <div className="i-c-item" key={index}>
                <img className="i-c-i-img" src={item.img} alt="i-c-img" />
                <div>
                  <div className="i-c-i-title">{item.title}</div>
                  <div className="i-c-i-text">{item.desc}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      {/* 精彩案例 */}
      <div className="case">
        <div className="title">{TXT_INFO.case}</div>
        <div
          className="more"
          onClick={() => {
            navigate("/case");
          }}
        >
          {TXT_INFO.more}
        </div>
        <div className="c-container">
          {cases?.map((item: any) => {
            return (
              <div className="c-c-ul">
                {item?.map((c: any) => {
                  const liStyle = {
                    backgroundImage: `url(${c.img})`,
                  };
                  return (
                    <div
                      className="c-c-li"
                      style={liStyle}
                      onClick={() => {
                        navigate("/detail", {
                          state: {
                            url: "/index/cases/detail",
                            id: c?.id,
                          },
                        });
                      }}
                    >
                      <div className="c-c-li-bottom">
                        <div className="c-c-li-b-title">{c?.title}</div>
                        <div className="c-c-li-b-btn">{TXT_INFO.learnMore}</div>
                      </div>
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
      </div>
      {/* 做值得信赖的服务商 */}
      <div className="facilitator">
        <div className="title">{TXT_INFO.server}</div>
        <div
          className="more"
          onClick={() => {
            navigate("/about");
          }}
        >
          {TXT_INFO.more}
        </div>
        <div className="f-container">
          <div className="fc-box">
            <div className="f-c-l">
              <div dangerouslySetInnerHTML={{ __html: companyInfo?.detail }} />
            </div>
            <img className="f-c-r" src={companyImg?.[0]?.url} />
          </div>
          {firends?.length ? (
            <div className="fc-firend">
              <div className="fc-f-title">{TXT_INFO.firend}</div>
              <div className="fc-f-ul">
                <InfinitePartnerScroll partners={firends} />
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default HomePage;
